import { useState } from 'react';
import { gio, tien, truocDay } from '../chung/api';
import { useHoiLai } from '../chung/hoi-lai';
import type { Don, TrangDon, TrangThaiDon } from '../chung/kieu';
import { DaiLoi, HopHoi, Khung } from './manh';

/**
 * Đơn hàng — CHỈ XEM.
 *
 * 🔴 Không có một nút nào đổi được dữ liệu ở đây, và đó là chủ ý.
 *
 *    Thu tiền · huỷ giỏ · trả lại đơn đều đã có chỗ của nó ở màn thu ngân, nơi
 *    người bấm đang đứng trước mặt khách. Đặt thêm một đường thứ hai ở màn quản
 *    lý nghĩa là cùng một việc có hai chỗ làm, hai luồng xác nhận, và sáu tháng
 *    sau không ai chắc chỗ nào mới là chỗ đúng. Mục này để TRA, không để LÀM.
 */
const NHAN: Record<TrangThaiDon, { ten: string; the: string }> = {
  DANG_MUA: { ten: 'Đang thêm', the: 'the-mo' },
  /** Khong sinh ra nua tu 04/09 — giu nhan cho nhung don cu. */
  CHO_THU_TIEN: { ten: 'Chờ thu tiền (cũ)', the: 'the-nhan' },
  DA_THU_TIEN: { ten: 'Hoàn thành', the: 'the-tot' },
  DA_HUY: { ten: 'Đã huỷ', the: 'the-mo' },
};

const LOC: { ma: string; ten: string }[] = [
  { ma: '', ten: 'Tất cả' },
  { ma: 'dang-mo', ten: 'Đang mở' },
  { ma: 'DA_THU_TIEN', ten: 'Hoàn thành' },
  { ma: 'DA_HUY', ten: 'Đã huỷ' },
];

const chip: React.CSSProperties = {
  padding: '8px 15px',
  fontSize: 13,
  fontWeight: 600,
  borderRadius: 'var(--tron)',
  whiteSpace: 'nowrap',
};

export function MucDonHang() {
  const [tt, datTt] = useState('');
  const [ngay, datNgay] = useState('');
  const [trang, datTrang] = useState(1);
  const [xemId, datXemId] = useState<number | null>(null);

  const ts = new URLSearchParams();
  if (tt) ts.set('trang_thai', tt);
  if (ngay) ts.set('ngay', ngay);
  if (trang > 1) ts.set('trang', String(trang));

  // 15 giây, không phải 2,5 giây như hàng đợi thu ngân: đây là màn TRA CỨU, không
  // ai đứng chờ một con số đổi. Hỏi lại dày ở một truy vấn quét cả bảng đơn là
  // tốn vô ích.
  const kq = useHoiLai<TrangDon>(`/api/don?${ts}`, 15_000);

  const ds = kq.duLieu?.danh_sach ?? [];
  // Lấy lại từ danh sách MỚI NHẤT thay vì giữ bản chụp lúc bấm — nếu thu ngân
  // vừa thu tiền xong thì hộp đang mở phải đổi trạng thái theo, không đứng yên
  // ở con số cũ.
  const xem = ds.find((d) => d.id === xemId) ?? null;

  const soTrang = kq.duLieu ? Math.max(1, Math.ceil(kq.duLieu.tong / kq.duLieu.moi_trang)) : 1;
  const doiLoc = (f: () => void) => {
    f();
    datTrang(1);
  };

  return (
    <Khung
      tieuDe="Đơn hàng"
      phu={kq.duLieu ? `${kq.duLieu.tong} đơn · chỉ xem, không sửa được ở đây` : 'Đang tải…'}
    >
      <DaiLoi loi={kq.loi} />

      <div style={{ display: 'flex', gap: 12, marginBottom: 16, alignItems: 'center', flexWrap: 'wrap' }}>
        {LOC.map((l) => (
          <button
            key={l.ma}
            onClick={() => doiLoc(() => datTt(l.ma))}
            className={tt === l.ma ? 'lom-nho' : undefined}
            style={{ ...chip, color: tt === l.ma ? 'var(--nhan)' : undefined }}
          >
            {l.ten}
          </button>
        ))}
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 10, alignItems: 'center' }}>
          <span className="nhan-chu">Ngày làm việc</span>
          <input
            type="date"
            value={ngay}
            onChange={(e) => doiLoc(() => datNgay(e.target.value))}
            style={{ width: 190 }}
          />
          {ngay && (
            <button onClick={() => doiLoc(() => datNgay(''))} style={{ padding: '11px 14px', fontSize: 13 }}>
              Bỏ lọc ngày
            </button>
          )}
        </div>
      </div>

      {!kq.duLieu && [0, 1, 2, 3].map((i) => <div key={i} className="xuong" style={{ height: 58, marginBottom: 12 }} />)}

      {kq.duLieu && ds.length === 0 && (
        <div style={{ padding: '40px 10px', textAlign: 'center', color: 'var(--chu-3)' }}>
          Không có đơn nào khớp.
        </div>
      )}

      {ds.map((d, i) => (
        <button
          key={d.id}
          onClick={() => datXemId(d.id)}
          className="noi-nho truot-phai"
          style={{
            animationDelay: `${Math.min(i, 8) * 30}ms`,
            width: '100%',
            textAlign: 'left',
            display: 'block',
            padding: '13px 18px',
            marginBottom: 12,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <span className="so" style={{ fontSize: 20, fontWeight: 800, flexShrink: 0 }}>
              {d.ma}
            </span>
            <span className={`the ${NHAN[d.trang_thai].the}`}>{NHAN[d.trang_thai].ten}</span>
            {d.so_lan_tra_lai > 0 && (
              <span className="the the-cho">Trả lại {d.so_lan_tra_lai}×</span>
            )}
            {/* Tên người có thể dài — cắt bớt tên, không bao giờ ép số tiền co lại. */}
            <span
              style={{
                flex: 1,
                minWidth: 0,
                fontSize: 12,
                color: 'var(--chu-2)',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {d.ngay} · {d.nguoi_tao.ho_ten} · {d.dong.length} món
            </span>
            <span className="tien" style={{ fontSize: 'var(--chu-to)', flexShrink: 0 }}>
              {tien(d.tien.tong)}
            </span>
          </div>
        </button>
      ))}

      {soTrang > 1 && (
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', justifyContent: 'center', marginTop: 8 }}>
          <button onClick={() => datTrang((c) => Math.max(1, c - 1))} disabled={trang <= 1} style={{ padding: '11px 18px' }}>
            ← Trước
          </button>
          <span className="so" style={{ fontSize: 13, color: 'var(--chu-2)' }}>
            {trang} / {soTrang}
          </span>
          <button
            onClick={() => datTrang((c) => Math.min(soTrang, c + 1))}
            disabled={trang >= soTrang}
            style={{ padding: '11px 18px' }}
          >
            Sau →
          </button>
        </div>
      )}

      {xem && <HopChiTiet don={xem} dong={() => datXemId(null)} />}
    </Khung>
  );
}

function HopChiTiet({ don, dong }: { don: Don; dong: () => void }) {
  return (
    <HopHoi tieuDe={`Đơn ${don.ma}`} nutY="Đóng" dangLam={false} dong={dong} dongY={dong} anQuayLai>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 16, flexWrap: 'wrap' }}>
        <span className={`the ${NHAN[don.trang_thai].the}`}>{NHAN[don.trang_thai].ten}</span>
        <span style={{ fontSize: 12, color: 'var(--chu-3)' }}>
          ngày làm việc {don.ngay} · mở {truocDay(don.tao_luc)}
        </span>
      </div>

      <div className="lom-nho" style={{ padding: '13px 16px', marginBottom: 16, fontSize: 'var(--chu-nho)', lineHeight: 1.8 }}>
        <div>
          Người mở: <b style={{ color: 'var(--chu)' }}>{don.nguoi_tao.ho_ten}</b>
        </div>
        {don.thu_ngan && (
          <div>
            Thu ngân: <b style={{ color: 'var(--chu)' }}>{don.thu_ngan.ho_ten}</b>
          </div>
        )}
        {don.so_lan_tra_lai > 0 && (
          <div style={{ color: 'var(--nhan)', fontWeight: 600 }}>
            Đã trả lại {don.so_lan_tra_lai} lần
          </div>
        )}
        {don.them_hang_lan_cuoi && <div>Thêm hàng lần cuối: {gio(don.them_hang_lan_cuoi)}</div>}
      </div>

      {/* Mỗi dòng ghi rõ AI thêm — đây là dữ liệu tính thưởng, và là lý do dòng
          chỉ gộp khi cùng sản phẩm + cùng người thêm + cùng giá. */}
      {don.dong.map((d) => (
        <div
          key={d.id}
          className="noi-nho"
          style={{ padding: '11px 14px', marginBottom: 10, display: 'flex', gap: 12, alignItems: 'center' }}
        >
          <span className="gieng so" style={{ width: 34, height: 34, flexShrink: 0, fontSize: 14 }}>
            {d.so_luong}
          </span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600, fontSize: 'var(--chu-nho)' }}>{d.ten}</div>
            <div style={{ fontSize: 11, color: 'var(--chu-3)', marginTop: 3 }}>
              {d.sku} · {tien(d.don_gia)}
              {d.giam > 0 && <span style={{ color: 'var(--nhan)' }}> · giảm {tien(d.giam)}</span>}
              {d.nguoi_them && ` · ${d.nguoi_them.ho_ten} thêm`}
            </div>
          </div>
          <span className="tien" style={{ flexShrink: 0 }}>
            {tien(d.thanh_tien)}
          </span>
        </div>
      ))}

      {don.ghi_chu && (
        <div className="lom-nho" style={{ padding: '12px 16px', marginTop: 14, fontSize: 'var(--chu-nho)' }}>
          <span className="nhan-chu">Ghi chú</span>
          <div style={{ marginTop: 5 }}>{don.ghi_chu}</div>
        </div>
      )}

      <div className="lom" style={{ padding: '16px 20px', marginTop: 16 }}>
        <Dong nhan="Tạm tính" so={tien(don.tien.truoc_giam)} />
        {don.tien.giam_tung_dong > 0 && (
          <Dong nhan="Giảm theo sản phẩm" so={`− ${tien(don.tien.giam_tung_dong)}`} mau="var(--nhan)" />
        )}
        {don.tien.giam_ca_don > 0 && (
          <Dong nhan="Giảm cả đơn" so={`− ${tien(don.tien.giam_ca_don)}`} mau="var(--nhan)" />
        )}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginTop: 10 }}>
          <span className="nhan-chu">Tổng</span>
          <span className="tien" style={{ fontSize: 'var(--chu-to)', fontWeight: 800 }}>
            {tien(don.tien.tong)}
          </span>
        </div>
      </div>
    </HopHoi>
  );
}

function Dong({ nhan, so, mau }: { nhan: string; so: string; mau?: string }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 'var(--chu-nho)', marginBottom: 6 }}>
      <span style={{ color: 'var(--chu-3)' }}>{nhan}</span>
      <span className="so" style={{ color: mau }}>
        {so}
      </span>
    </div>
  );
}
